import axios from "axios";
import queryString from 'query-string';
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

const STATE = ['past_class', 'current_class', 'all']

export default function getStudentClass(studentId, state) {

  if(!studentId){
    return new Promise((resolve, reject) => {
      reject({
        error: new Error('Missing student Id (number)')
      })
    })
  }

  if(!state){
    return new Promise((resolve, reject) => {
      reject({
        error: new Error('Missing state')
      })
    })
  }

  let newState = STATE.indexOf(state);

  return new Promise((resolve, reject) => {
    axios.put(APIAddress, {'uri': `/g_stdtcrtcls/${studentId}/${newState}`,
    'method': 'GET',
    'token': localStorage.getItem('token')})
    .then((res) => {
      resolve(res.data);
    })
    .catch((err) => {
      reject(err);
    })
  })
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/student/getStudentClass.js